import * as yup from "yup";

export const addUserDetailsSchema = yup.object().shape({
  LoginId: yup.string().trim().required("Login Id is required!"),
  EmailId: yup
    .string().trim()
    .email("Please enter valid email!")
    .required("Email Id is required!"),
  FirstName: yup
    .string().trim()
    .required("First Name is required!")
    .max(20, "Only 20 characters allowed!")
    .matches(
      /^[a-zA-Z0-9.`\]\[ ]*$/,
      "Only alphanumeric and special characters like .` are allowed"
    ),
  MiddleName: yup
    .string().trim()
    .notRequired()
    .nullable()
    .max(20, "Only 20 characters allowed!")
    .matches(
      /^[a-zA-Z0-9.`\]\[ ]*$/,
      "Only alphanumeric and special characters like .` are allowed"
    ),
  LastName: yup
    .string().trim()
    .required("Last Name is required!")
    .max(20, "Only 20 characters allowed!")
    .matches(
      /^[a-zA-Z0-9.`\]\[ ]*$/,
      "Only alphanumeric and special characters like .` are allowed"
    ),
  //  DomainName: yup
  // .array(
  //   yup.object().shape({
  //     Name: yup.string().required(),
  //     Id: yup.number(),
  //   }).required()
  // )
  // .nullable()
  // .min(1, "Domain Name is required!"),  
});

export const selectUserLocationSchema = yup.object().shape({
  Country: yup.string().notRequired().nullable(),
  State: yup.string().notRequired().nullable(),
  City: yup.string().notRequired().nullable(),
  Store: yup
    .array(
      yup.object().shape({
        StoreName: yup.string().notRequired(),
        StoreId: yup.string().notRequired(),
      })
    )
    .notRequired()
    .nullable().max(20, "Only 20 Locations are allowed"),
});

// let Category = yup.array(
//   yup.object().shape({
//     CategoryId: yup.string().notRequired().nullable(),
//     Name: yup.string().notRequired().nullable(),
//     ParentCategoryId: yup.string().notRequired().nullable(),
//     SubCategory: yup.array().of(yup.lazy(() => Category.default(undefined))),
//     TenantId: yup.number().notRequired().nullable(),
//     ImgUrl: yup.string().notRequired().nullable(),
//     isExpanded: yup.boolean().notRequired().nullable(),
//     isFiltered: yup.boolean().notRequired().nullable(),
//     isActive: yup.boolean().notRequired().nullable(),
//     selected: yup.boolean().notRequired().nullable(),
//   })
// );

export const addAdditionalDetailsSchema = yup.object().shape({
  //   Category: Category.notRequired().nullable(),
  Category: yup
    .array(
      yup.object().shape({
        Name: yup.string().notRequired(),
        CategoryId: yup.string().notRequired(),
      })
    )
    .notRequired()
    .nullable().max(20, "Only 20 User Departments are allowed"),
  AssociatedRoles: yup
    .array(
      yup.object().shape({
        RoleName: yup.string().notRequired(),
        RoleID: yup.number().notRequired(),
      })
    )
    .notRequired()
    .nullable(),
  UserGroupDetails: yup
    .array(
      yup.object().shape({
        //   StoreId: yup.string(),
        //   StoreName: yup.string(),
        Name: yup.string().notRequired(),
        UserGroupId: yup.number().notRequired(),
      })
    )
    .max(20, "Maximum 20 User Groups are allowed")
    .notRequired()
    .nullable(),
});
